(function () {
  var MOBILE_MAX_WIDTH = 805;
  var SWIPE_THRESHOLD = 50;
  var MAX_VERTICAL_DRIFT = 30;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function getActiveGalleryContainers() {
    var productBox = document.querySelector('.product-box');
    if (!productBox) return [];

    return Array.from(productBox.querySelectorAll('.grid-container-mobile, .grid-container')).filter(
      isElementVisible
    );
  }

  function getGridItems() {
    var productBox = document.querySelector('.product-box');
    if (!productBox) return [];

    var containers = getActiveGalleryContainers();
    if (!containers.length) {
      containers = [productBox];
    }

    var seen = {};
    var items = [];

    containers.forEach(function (container) {
      Array.from(container.querySelectorAll('.product-img-grid-item')).forEach(function (item) {
        var id = item.getAttribute('data-media-id');
        if (!id || seen[id]) return;
        seen[id] = true;
        items.push(item);
      });
    });

    return items;
  }

  function getMainImageSizes() {
    return isMobile() ? '100vw' : '(max-width: 805px) 100vw, 800px';
  }

  function changeBigPicture(gridItem) {
    var mainImg = document.querySelector('.featured-product-image img');
    var popupImg = document.querySelector('.popup-product-img img');
    if (!mainImg || !gridItem) return;

    var thumbImg = gridItem.querySelector('img');
    var mainSrc = gridItem.getAttribute('data-main-src');
    var mainSrcset = gridItem.getAttribute('data-main-srcset');
    var popupSrc = gridItem.getAttribute('data-popup-src');
    var popupSrcset = gridItem.getAttribute('data-popup-srcset');

    if (mainSrc) {
      mainImg.src = mainSrc;
    } else if (thumbImg) {
      mainImg.src = thumbImg.currentSrc || thumbImg.src;
    }

    mainImg.alt = (thumbImg && thumbImg.alt) || '';
    mainImg.id = 'main-product-image';
    mainImg.style.display = 'block';
    mainImg.style.width = '100%';
    mainImg.style.maxWidth = '800px';
    mainImg.style.height = 'auto';
    mainImg.style.marginRight = 'auto';
    mainImg.style.marginLeft = 'auto';
    mainImg.removeAttribute('width');
    mainImg.removeAttribute('height');

    if (mainSrcset) {
      mainImg.setAttribute('srcset', mainSrcset);
      mainImg.setAttribute('sizes', getMainImageSizes());
    } else {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
    }

    if (popupImg) {
      popupImg.src = popupSrc || mainSrc || (thumbImg && (thumbImg.currentSrc || thumbImg.src)) || popupImg.src;

      if (popupSrcset) {
        popupImg.setAttribute('srcset', popupSrcset);
        popupImg.setAttribute('sizes', '100vw');
      } else {
        popupImg.removeAttribute('srcset');
        popupImg.removeAttribute('sizes');
      }
    }
  }

  function updateFeaturedMediaId(item) {
    var featured = document.querySelector('.featured-product-image');
    var mediaId = item.getAttribute('data-media-id');
    if (featured && mediaId) {
      featured.setAttribute('data-media-id', mediaId);
    }
  }

  function setActiveThumbnail(activeItem) {
    var activeId = activeItem && activeItem.getAttribute('data-media-id');
    document.querySelectorAll('.product-box .product-img-grid-item').forEach(function (item) {
      item.classList.toggle('is-active', activeId && item.getAttribute('data-media-id') === activeId);
    });
  }

  function activateGridItem(item) {
    if (!item) return;

    var mediaType = item.getAttribute('mediaType');
    if (mediaType === 'image') {
      changeBigPicture(item);
    } else {
      item.click();
    }

    updateFeaturedMediaId(item);
    setActiveThumbnail(item);
  }

  function getCurrentIndex(items) {
    var featured = document.querySelector('.featured-product-image');
    if (!featured) return 0;

    var activeId = featured.getAttribute('data-media-id');
    if (activeId) {
      var matchIndex = items.findIndex(function (item) {
        return item.getAttribute('data-media-id') === activeId;
      });
      if (matchIndex >= 0) return matchIndex;
    }

    var activeItem = document.querySelector('.product-img-grid-item.is-active');
    if (activeItem) {
      var activeIndex = items.indexOf(activeItem);
      if (activeIndex >= 0) return activeIndex;
    }

    var mainImg = featured.querySelector('img');
    if (!mainImg) return 0;

    for (var i = 0; i < items.length; i++) {
      var thumb = items[i].querySelector('img');
      if (thumb && (thumb.src === mainImg.src || thumb.currentSrc === mainImg.currentSrc)) return i;
    }

    return 0;
  }

  function showItem(items, index) {
    if (index < 0 || index >= items.length) return;
    activateGridItem(items[index]);
  }

  function initThumbnailClicks() {
    var productBox = document.querySelector('.product-box');
    if (!productBox || productBox.dataset.thumbClickBound === 'true') return;

    productBox.addEventListener(
      'click',
      function (e) {
        var item = e.target.closest('.product-img-grid-item');
        if (!item || !productBox.contains(item)) return;

        var mediaType = item.getAttribute('mediaType');
        if (mediaType === 'image') {
          e.preventDefault();
          e.stopImmediatePropagation();
          changeBigPicture(item);
          updateFeaturedMediaId(item);
          setActiveThumbnail(item);
          return;
        }

        updateFeaturedMediaId(item);
        setActiveThumbnail(item);
      },
      true
    );

    productBox.dataset.thumbClickBound = 'true';

    var items = getGridItems();
    if (items.length) {
      setActiveThumbnail(items[getCurrentIndex(items)]);
    }
  }

  function initProductSwipe() {
    var container = document.querySelector('.product-mobile-swipe-target');
    if (!container || container.dataset.swipeBound === 'true') return;

    var startX = 0;
    var startY = 0;

    container.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobile()) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    container.addEventListener(
      'touchend',
      function (e) {
        if (!isMobile()) return;

        var items = getGridItems();
        if (items.length < 2) return;

        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var dx = endX - startX;
        var dy = Math.abs(endY - startY);

        if (Math.abs(dx) < SWIPE_THRESHOLD || dy > MAX_VERTICAL_DRIFT) return;

        var current = getCurrentIndex(items);
        if (dx < 0) {
          showItem(items, (current + 1) % items.length);
        } else {
          showItem(items, (current - 1 + items.length) % items.length);
        }
      },
      { passive: true }
    );

    container.dataset.swipeBound = 'true';
  }

  function init() {
    initThumbnailClicks();
    initProductSwipe();
  }

  window.productMobileSwipeChangeBigPicture = changeBigPicture;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
